<template>
    <HeadingContainer :heading="smallOrLess ? null : 'Account Settings'">
        <div class="row mb3 mb4-ns">

            <!-- left cards -->
            <div v-if="!smallOrLess" class="col-xs-12 col-md-4">
                <NameCard height="90" :user="user" class="mt4"/>
                <SettingsList class="mt4"/>
            </div>

            <!-- right cards -->
            <div class="col-xs-12 col-md-8">
                <div class="mt4-ns"><slot></slot></div>
            </div>

        </div>
        <SingleButtonActionbar text="Update" @click="$emit('buttonClick')"/>
    </HeadingContainer>

</template>

<script>
import HeadingContainer from '@/components/layout/HeadingContainer.vue';
import NameCard from '@/components/accountSettings/NameCard.vue';
import SettingsList from '@/components/accountSettings/settingsMenu/SettingsMenu.vue';
import SingleButtonActionbar from '@/components/global/SingleButtonActionbar.vue';
import { mapState } from 'vuex';

export default {
    components: {
        HeadingContainer,
        NameCard,
        SettingsList,
        SingleButtonActionbar
    },
    computed: {
        ...mapState('users', ['user']),
        smallOrLess() {
            return this.$mq === 'xs' || this.$mq === 'sm';
        }
    }
};
</script>
